import BankImg from "../../assets/img/fluent_shield.svg";
import BellIcon from "../../assets/img/bell-icon.svg";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import { dummyProfiles } from "../../Utils/constants";

const LandlordBankCard = (props) => {
  const {
    showReportIcons,
    sendRemainderLoading,
    isUserTenantCheck,
    handleSendRemainder,
    user,
  } = props;
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { user: originalUser } = useContext(AuthContext);
  const handleInitiateTink = () => {
    const neededUserId = haveValue(user?.gurantor_for[0])
      ? user?.gurantor_for
      : user?._id;
    navigate(
      `/${workspaceId}/tenant-check/create?tenant_id=${neededUserId}&reCheck=true`
    );
  };

  return isUserTenantCheck ? (
    <>
      <div className="conact-back-info h-100">
        <div className="bank-conact-wrapper">
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between align-items-start gap-4">
              <div>
                <h4 className={`mb-0 `}>
                  {user?.bank_status == true &&
                    !haveValue(user?.paymentScores) && (
                      <img
                        src="/gif/loading-gif.mov.gif"
                        className="loadingGif"
                      />
                    )}
                  {user?.bank_status == true && !haveValue(user?.paymentScores)
                    ? `${_t(
                        "SkorIsBeingGenerated",
                        "On LL side when LL creates a tenant checks profile and has not connected bank on home screen"
                      )}...`
                    : _t(
                        "financialVerificationPending",
                        "On LL side when LL creates a tenant checks profile and has not connected bank on home screen"
                      )}
                </h4>
              </div>
              <div className="Securedbtn d-flex justify-content-between align-items-center gap-2 hideOnMobile">
                <img src={BankImg} alt="img" />
                <span className="">
                  {_t(
                    "secured",
                    "New tenant side screen connect bank component"
                  )}
                </span>
              </div>
            </div>

            <p>
              {_t(
                "financialVerificationDescBeingUsedInWhenProfileCreatedWithTenantChecksAndLLLandsOnProfileHomePage",
                "On LL side when LL creates a tenant checks profile and has not connected bank on home screen"
              )}
            </p>

            <div className="Securedbtn d-flex justify-content-between align-items-center gap-2 hideOnDesktop">
              <img src={BankImg} alt="img" />
              <span className="">
                {_t("secured", "New tenant side screen connect bank component")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center custom-gap-2">
            {(user?.bank_status == true && !haveValue(user?.paymentScores)) ||
            !WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
              originalUser?.current_workspace_role
            ) ? (
              ""
            ) : (
              <button onClick={handleInitiateTink}>
                {_t(
                  "verifyNow",
                  "New tenant side screen connect bank component"
                )}
                <img src="/images/arrow-right.svg" />
              </button>
            )}

            <div className="bankIconWrapper d-flex justify-content-center align-items-center">
              <img src="/images/bank-icon.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="Profile_summary2 notAvailableSkor skorsetbox p-3 d-flex justify-content-center flex-column">
      <div className="bell-icon-wrapper">
        <img src={BellIcon} alt="Bell Icon" />
      </div>
      <p>
        {_t(
          "thisTenantHaventdonetheirfinancialSkorYetYouCanSendRemainderToTheTenantToGetTheirSkorDone"
        )}
      </p>
      {showReportIcons &&
        WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
          originalUser?.current_workspace_role
        ) && (
          <button
            disabled={
              sendRemainderLoading || dummyProfiles.includes(user?.email)
            }
            onClick={() => handleSendRemainder()}
            className="send-reminder-button"
          >
            {sendRemainderLoading ? `${_t("sending")}...` : _t("sendRemainder")}
          </button>
        )}
    </div>
  );
};

export default LandlordBankCard;
